import { ApiClient } from "./ApiClient";
import { RealmLower } from "../constants";
import { ServiceResult } from "./index";
import { toErrorMessage } from "../utils/ErrorMessage";

export interface ScheduledEventInfo {
  group: string;
  scheduleExpression: string;
  state: string;
  targetArn: string | null;
}

export interface ScheduledEventsResponse {
  customerId: string;
  schedules: ScheduledEventInfo[];
}

export class ScheduledEventsService {
  private api: ApiClient;

  constructor(api: ApiClient = ApiClient.getInstance()) {
    this.api = api;
  }

  async fetchSchedules(realm: RealmLower, customerId: string): Promise<ServiceResult<ScheduledEventsResponse>> {
    try {
      const base = this.api.getBaseUrl("scheduled-events", realm);
      const region = this.api.getRegionCode(realm);
      const url = `${base}/scheduled-events?id=${customerId}&region=${region}`;
      const data = await this.api.get<ScheduledEventsResponse>(url);
      return { status: "ok", data };
    } catch (err) {
      return { status: "error", message: toErrorMessage(err) };
    }
  }
}
